import { SENSOR_DATA_ROOM } from '@/interfaces/sensordata.interface'
export interface STATE {
  currentDrawingTransparency: number
  currentHeatmapIntensity: number // Todo: start value should be 0.5 if this is implemented for ordinary heatmaps with more points
  currentModel: string | null
  currentSensordataType: string | null
  filteredLayers: any[]
  indoorZonesForSelectedLevel: object[]
  isLoadingModel: boolean
  isLoadingSensordata: boolean
  isSensordataShowing: boolean
  heatmapDateArray: any
  hoveredSensorData: string | null
  selectedHeatmapDate: Date | null
  selectedRoomSensorData: any
  sensordataTypesForSelectedLevel: string[]
  zoneCategoriesForSelectedLevel: object[]
  sensorDataForSelectedLevel: SENSOR_DATA_ROOM[]
}

const state: STATE = {
  currentDrawingTransparency: 0.8,
  currentHeatmapIntensity: 0.85, // Todo: start value should be 0.5 if this is implemented for ordinary heatmaps with more points
  currentModel: null,
  currentSensordataType: null,
  filteredLayers: [],
  indoorZonesForSelectedLevel: [],
  isLoadingModel: false,
  isLoadingSensordata: false,
  isSensordataShowing: false,
  heatmapDateArray: null,
  hoveredSensorData: null,
  selectedHeatmapDate: null,
  selectedRoomSensorData: null,
  sensordataTypesForSelectedLevel: [],
  zoneCategoriesForSelectedLevel: [],
  sensorDataForSelectedLevel: []
}
export default state
